import EmblaCarousel from "embla-carousel";

class ImageCarousel extends HTMLElement {
  constructor() {
    super();

    this.state = {};

    this.setup = this.setup.bind(this);
    this.teardown = this.teardown.bind(this);
    this.viewport = this.querySelector(".carousel-viewport");
    this.prev = this.parentElement.querySelector(".prev");
    this.next = this.parentElement.querySelector(".next");

    this.setup();
  }

  setup() {
    if (this.querySelectorAll(".carousel-image").length <= 1) {
      return;
    }
    const options = {
      loop: this.dataset.loop,
      align: this.dataset.align,
    };

    this.embla = EmblaCarousel(this.viewport, options);

    this.prev.addEventListener("click", this.embla.scrollPrev, false);
    this.next.addEventListener("click", this.embla.scrollNext, false);

    // Lock horizontal scroll for parent element
    // this.parentElement.addEventListener('scroll', this.resetScrollPosition)

    // Jump to focused slide when moving with keyboard
    this.addEventListener("focusin", this.handleSlideFocusIn);

    if (this.state.selectedScrollSnap) {
      this.embla.scrollTo(this.state.selectedScrollSnap);
    }
  }

  teardown() {
    if (this.embla) {
      this.state.selectedScrollSnap = this.embla.selectedScrollSnap;
      this.embla.destroy();
      this.parentElement.removeEventListener("scroll", this.handleSlideFocusIn);
      this.removeEventListener("focusin", this.handleSlideFocusIn);
    }
  }

  resetScrollPosition() {
    this.parentElement.scrollTo(0, 0);
  }

  handleSlideFocusIn(event) {
    const slide = event.target.closest(".carousel-image");
    const slideIndex = parseInt(slide.getAttribute("data-slide-index"), 10) - 1;

    this.embla.scrollTo(slideIndex, true);
  }
}

customElements.define("image-carousel", ImageCarousel);
